import { render } from "./Categories.vue?vue&type=template&id=76b163ee&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-76b163ee"

export default script